import { api } from '@/api'
import BackLink from '@/components/BackLink'
import Container from '@/components/Container'
import DetailPageHead from '@/components/DetailPageHead/index.tsx'
import { usePage } from '@/hooks'
import qs from 'query-string'
import { ILessonDetail } from '@/interfaces/Lessons'
import React, { useEffect, useState } from 'react'
import useSWR from 'swr'
import LessonsSlider from '../RecommendToKnow/components/LessonsSlider'

const Lesson = (): React.ReactElement => {
  const [lesson, setLesson] = useState<ILessonDetail | undefined>()
  const [parsed, setParsed] = useState<any>('')

  const page = usePage()
  const { data: lessons } = useSWR(
    { url: 'lessons', page_size: 1000 },
    api.getLessons
  )

  const { object } = page.init_state

  const backLink = typeof parsed?.link === 'string' ? parsed.link : '/'
  const backTitle = typeof parsed?.title === 'string' ? parsed.title : 'Назад'

  useEffect(() => {
    setParsed(qs.parse(location.search))
  }, [])

  useEffect(() => {
    api
      .getLesson({ id: object.id })
      .then((data) => {
        setLesson(data)
      })
      .catch((error) => {
        console.error(error)
      })
  }, [object.id])
  return (
    <>
      <Container>
        <BackLink href={backLink} title={backTitle} />

        {lesson !== undefined
          ? (
            <DetailPageHead
              image={lesson.detail_picture}
              date={lesson.date_create}
              title={lesson.name}
              content={lesson.detail_text}
            />
            )
          : null}
      </Container>

      <LessonsSlider
        lessons={lessons?.results}
        prefix={`lesson_${object.id}`}
        backLink={backLink}
        backTitle={backTitle}
      />
    </>
  )
}

export default Lesson
